import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ApiResponseData, ParkingLot, ReqManagerId, ResponseApiResponse } from '@core/models/api-response.model';
import { Utility } from 'src/app/shared';
import { APIService } from '@core/services/api.service';
import { BookingSummary, Dispatcher, DispatcherRequest } from '../models/super-admin-api.response.modal';
import { SpecialRates } from '@core/models/booking-flow-v1.model';
import { EncryptionStorageService } from './encryption-storage.service';

@Injectable({
  providedIn: 'root'
})
export class SuperAdminService {
  private readonly showInputSource = new BehaviorSubject<boolean>(false);
  showInput$ = this.showInputSource.asObservable();
  private readonly popupClosedSubject = new Subject<boolean>();
  popupClosed$ = this.popupClosedSubject.asObservable();
  constructor(private readonly apiService: APIService, private readonly encryptStorage: EncryptionStorageService) { }

  getCompanyList(search) {
    return this.apiService.post('Dashboard/GetCompanyList' ,search)
  }

  getDriverLeaderBoard(req : any) {

    return this.apiService.post<ApiResponseData[]>('Dashboard/GetDriverLeaderBoard', req)
  }
 
  getDashboardDataByManagerId(_data: ReqManagerId) {
    return this.apiService.post<ResponseApiResponse>(`Dashboard/GetDashboardDataByManagerId`, _data)
  }

  addCustomCredit(data: any) {
    return this.apiService.postWithAllResponse<ResponseApiResponse>('User/AddCustomCredit', data);
  }

  getAllUser(data: any) {
    return this.apiService.postWithAllResponse<ResponseApiResponse>('User/GetAllUser', data);
  }

  getOccupiedAndVacantParkingLots(data: ReqManagerId) {
    return this.apiService.post(`Dashboard/GetOccupiedAndVacantParkingLots`, data)
  }
  getGraphRevenueDetailsSuperAdmin(req){
    return this.apiService.post('Dashboard/GetGraphRevenueDetails' , req);
  }
  getOccupiedAndVacantParkingForLotsGraph(req) {
    return this.apiService.post('Dashboard/GetOccupiedAndVacantParkingForLotsGraph' , req)
  }
  getParkingLotByStatesName(id: string): Observable<ParkingLot[]> {
    const timeZone = Utility.getLocalTimeZone();
    return this.apiService.get<ParkingLot[]>(`Dashboard/GetParkingLotByStatesName?state=&companyId=${id}&timeZone=${timeZone}`);
  }
  getParkingLotNamesByCompanyIds(req : any){
    return this.apiService.postWithAllResponse('ParkingLot/GetParkingLotNamesByCompanyIds',req)
  }
  getParkingLotByStatesNameForOffer(id: string, searchKeyword: string): Observable<ParkingLot[]> {
    const timeZone = Utility.getLocalTimeZone();
    return this.apiService.get<ParkingLot[]>(`Dashboard/GetParkingLotByStatesName?searchKeyword=${searchKeyword}&companyId=${id}&timeZone=${timeZone}`);
  }
  getAppDetails(data):Observable<any>{
    return this.apiService.post<any>(`AppDetail/GetAppDetails`, data);
  }
  getUserList(data):Observable<any>{
    return this.apiService.post<any>(`User/GetUserList`, data);
  }
  setSkipRecords(skipRecords: number): void {
    this.encryptStorage.setItem('skipRecords', JSON.stringify(skipRecords));
  }
  getSkipRecords(): number {
    const skipRecords = this.encryptStorage.getItem('skipRecords');
    if (skipRecords) return +JSON.parse(skipRecords);
    return 0;
  }
  setCurrentPage(page: number): void {
    this.encryptStorage.setItem('currentPage', JSON.stringify(page));
  }
  getBookingListBySuperAdminId(req : any){
   return this.apiService.post('BookingSlot/GetBookingListBySuperAdminId' , req)
  }
  getCompanyListForDropdown(req){
    return this.apiService.post('Dashboard/GetCompanyListById',req)
  }
  getOfferListforSuperAdmin(req){
    return this.apiService.postWithAllResponse('Dashboard/GetSuperAdminOfferList',req)
  }
  activeDeactiveOffers(req){
    return this.apiService.post('Dashboard/ActiveDeactiveOffer',req)
  }
  getAppDownloadDetail(req){
    return this.apiService.post('AppDetail/GetAppDownloadsDetails',req)
  }
  getPerformanceMetricsGraphData(req){
    return this.apiService.post('AppDetail/GetPerformanceMetricsGraphData',req)
  }

  getAppDownloadAndRegisteredCount(req){
    return this.apiService.post('AppDetail/GetAppDownloadAndRegisteredCount',req)
  }
  getSuperAdminParkingLotList(req){
 return this.apiService.postWithAllResponse('ParkingLot/GetSuperAdminParkingLotList',req)
  }

  getDriverList(req){
    return this.apiService.postWithAllResponse('User/DriverListCreatedBySuperAdmin',req)
  }

  CreateDriverBySuperAdmin(req){
    return this.apiService.postWithAllResponse('User/CreateDriverBySuperAdmin',req)
  }
  createNewVehicleForDriver(req){
    return this.apiService.postWithAllResponse('User/CreateNewVehicleForDriver',req)
  }
  EditVehicleForDriverBySuperAdmin(req){
    return this.apiService.postWithAllResponse('User/EditVehicleForDriverBySuperAdmin',req)
  }
  deleteDriverVehicleByVehicleId(req){
    return this.apiService.delete('User/DeleteDriverVehicleByVehicleId',req)
  }

  deleteDriverAccountBySuperAdmin(id){
    return this.apiService.delete('User/DeleteDriverAccountBySuperAdmin',id)
  }

  getAllVehicleByDriverId(driverId: string): Observable<ParkingLot[]> {
    return this.apiService.get(`User/GetAllVehicleByDriverId?driverId=${driverId}`);
  }

  getAllVehicleByDriverIdForGO(driverId: string, bookingId: string): Observable<ParkingLot[]> {
    return this.apiService.get(`User/GetAllVehicleByDriverId?driverId=${driverId}&bookingId=${bookingId}&groupUserDriverList=2`);
  }
  getAllVehiclesByDriverId(req) {
    return this.apiService.get('User/GetAllVehicleByDriverId',req);
  }
  getUserDetailsById(id){
    return this.apiService.get(`User/GetUserDetailById?id=${id}`);
  }
  getUserPermission(id){
    return this.apiService.get('Permission/getUserPermission',id);
  }
  activeOrDeactiveManagerOwner(id){
    return this.apiService.get('User/ActiveOrDeactiveManagerOwner',id);
  }
  resetUserPermission(id){
    return this.apiService.post(`Permission/ResetUserPermission?userId=${id}`);
  }
  updateUserPermission(req){
    return this.apiService.post('Permission/UpdateUserPermission',req);
  }
  editDriverProfile(req){
    return this.apiService.post('User/EditDriverProfile',req)
  }

  activeOrDeactivateDriver(parkingLotId){
    return this.apiService.postWithAllResponse(`/User/ActivateOrDeActivateUserBySuperAdmin`, parkingLotId)
  }
  resetPassword(request : any){
    return this.apiService.post(`User/ResetDriverPasswordBySuperAdmin`,request)
  }

  setShowInput(value: boolean) {
    this.showInputSource.next(value);
  }
  GetAllUserCreditsByDriverId(req){
    return this.apiService.postWithAllResponse(`User/GetAllUserCreditsByDriverId`,req)
  }

  getTransactionListForSuperAdmin(req: any){
    return this.apiService.post('BookingSlot/GetTransactionListForSuperAdmin',req);
  }

  sendInvoiceOnMail(req: any){
    return this.apiService.postWithAllResponse('BookingSlot/SendInvoiceOnMail',req);
  }

  viewInvoice(req: any){
    return this.apiService.post('BookingSlot/DownloadInvoice',req)
  }
  sendInvoice(req){
    return this.apiService.post('BookingSlot/SendInvoiceOnMail',req)
  }
 
  getHighestPayerByCompanyIdForSuperAdmin(req : any){
    return this.apiService.post('BookingSlot/getHighestPayerByCompanyIdForSuperAdmin',req)
  }
  getUserListForSuperAdmin(req : any){
    return this.apiService.postWithAllResponse('User/GetUserListForSuperAdmin',req)
  }
  
  getCheckInOutDetails( bookingId : string) {
    return this.apiService.get(`BookingSlot/GetCheckInOutDetails?bookingId=${bookingId}`)
  }

  getBookingDetailById(bookingId: string) {
    const timeZone = Utility.getLocalTimeZone();
    return this.apiService.get<BookingSummary>(`BookingSlot/getBookingDetailById?id=${bookingId}&timeZone=${timeZone}`);
  }

  getAllDispatcherList(dispatcherRequest: DispatcherRequest) {
    return this.apiService.postWithAllResponse<Dispatcher[]>('User/GetAllDispatcherList', dispatcherRequest);
  }
  
  getUserByEmailId(data) {
    return this.apiService.post('User/GetPredictiveSearchForUserByEmail', data);
  }

  getPredictiveSearchForDriverByEmailOrMobile(data) {
    return this.apiService.post('User/GetPredictiveSearchForDriverByEmailOrMobile', data);
  }


  UpdateParkingLotAccessCodes(req){
    return this.apiService.postWithAllResponse('ParkingLot/UpdateParkingLotAccessCodes', req)
  }
  downloadQRCode(req){
    return this.apiService.postWithAllResponse('Offer/GenerateOfferQR', req);
  }

  getParkingLotSpecialRateById(parkingLotId: string, spotTypeId: string): Observable<SpecialRates[]> {
    return this.apiService.get<SpecialRates[]>(`ParkingLot/GetParkingLotSpecialRateById?parkingLotId=${parkingLotId}&spotTypeId=${spotTypeId}`);
  }

  updateGroupUserProfile(request){
    return this.apiService.postWithAllResponse('User/UpdateGroupUserProfile', request)
   }

   getGroupBookingList(request){
    return this.apiService.postWithAllResponse('GroupBooking/GetGroupBookingList', request)
  }
  getPendingPaymentBookingList(request){
    return this.apiService.postWithAllResponse('BookingSlot/GetPendingPaymentBookingList', request)
  }
  
  getRevenueCollectionDashboard(request){
    return this.apiService.postWithAllResponse('ParkingLot/GetRevenueCollectionDashboard', request)
  }

  sendPaymentReminder(request){
    return this.apiService.postWithAllResponse('BookingSlot/SendPaymentReminder', request)
  }

  modifyOfferEndDate(request){
    return this.apiService.postWithAllResponse('Offer/ModifyOfferEndDate', request)
  }

  getCustomInvoiceDetailById(id: string) {
    const timeZone = Utility.getLocalTimeZone();
    return this.apiService.get(`Stripe/GetCustomInvoiceDetailById?id=${id}&timeZone=${timeZone}`);
  }
  triggerPopupClose(refresh: boolean) {
    this.popupClosedSubject.next(refresh);
  }
  getAllBookingsList(request){
    return this.apiService.postWithAllResponse('BookingSlot/GetAllBookingsList', request)
  }

  cancelRecurringBooking(request) {
    return this.apiService.postWithAllResponse('BookingSlot/CancelBooking', request)
  }
   cancelOneTimeBooking(request){
    return this.apiService.postWithAllResponse(`BookingSlot/CancelOneTimeBooking`,request)
  }
  getAllNotificationSetupDetails(){
    return this.apiService.getWithAllResponse('NotificationSetup/getAllNotificationSetupDetails');
  }

  updateNotificationSetupDetails(request){
   return this.apiService.postWithAllResponse('NotificationSetup/updateNotificationSetupDetails',request)
  }
  shareParkingInvoiceToDriver(request){
    return this.apiService.postWithAllResponse('ParkingLot/ShareParkingInvoiceToDriver', request)
  }
  customCreditList(request){
    return this.apiService.postWithAllResponse('User/GetCustomCreditList', request)
  }
  checkPendingDuesOrActiveBooking(userId){
    const timeZone = Utility.getLocalTimeZone();
    return this.apiService.getWithAllResponse(`User/CheckPendingDuesOrActiveBooking?userId=${userId}&timeZone=${timeZone}`);
  }
  createBulkUserByExcel(request){
    return this.apiService.postWithAllResponse('User/CreateBulkUserByExcel', request)
  }
  reAttemptPaymentFailedBookings(request){
    return this.apiService.postWithAllResponse('BookingSlot/ReAttemptPaymentFailedBookings', request)
  }
  getLastReAttemptPaymentFailedBookingsDetail(companyId: string) {
    return this.apiService.getWithAllResponse(`BookingSlot/GetLastReAttemptPaymentFailedBookingsDetail?companyId=${companyId}`);
  }

  getBookingListWithChildId(request) {
    return this.apiService.post('BookingSlot/GetBookingListWithChildId', request);
  }

  customBookingRefundBySuperAdmin(req) {
    return this.apiService.postWithAllResponse('BookingSlot/CustomBookingRefundBySuperAdmin', req);
  }

}
